<template>
  <v-container fluid class="ma-0 pa-0">
    <v-layout>
      <!-- FULL EDITION DIALOG -->
      <v-flex v-if="showFullEdition">
        <v-dialog
          :value="showFullEdition"
          class="ma-0 pa-0"
          persistent
          transition="dialog-bottom-transition"
        >
          <modify-mission-full-edition
            :itemSelected="itemSelected"
            :optionSelected="optionSelected"
            @cancel="cancelFullEdition"
            @finishAction="finishAction"
          />
        </v-dialog>
      </v-flex>
      <!-- CONTENT -->
      <v-flex>
        <h2>Modificar</h2>
        <v-flex class="container-info" ma-1 px-3 pt-2>
          <h2>Tipo de Modificación</h2>
          <p>Seleccione la opción qué quiere modificar:</p>
          <v-radio-group v-model="optionSelected">
            <v-radio
              v-for="(option, index) in optionsToModify"
              :key="index"
              :label="option.text"
              :value="option.value"
              @change="optionSelectedChanges"
            ></v-radio>
          </v-radio-group>
        </v-flex>
        
        <!-- ACTION BUTTON -->
        <v-flex v-if="optionSelected !== null" d-flex>
          <v-btn
            color="primary"
            :disabled="optionSelected === 1 && !itemSelected.actions.whereEditable"
            :loading="$loading.isLoading('gettingVehiclesInAMission')"
            @click="nextStep"
          >
            <v-icon left>navigate_next</v-icon>
            Continuar
          </v-btn>
        </v-flex>
        <!-- ALERT -->
        <v-flex 
          v-if="optionSelected !== null &&
            optionSelected === 1 &&
            !itemSelected.actions.whereEditable" mx-2
        >
          <v-alert
            :value="true"
            type="info"
            width="150"
          >
            Al no tener múltiples zonas no es posible modificar el Qué y Dónde de ésta misión.
          </v-alert>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ModifyMissionFullEdition from './ModifyMissionFullEdition'

import { missionInProgressMixin } from '../../../mixins/missionInProgressMixin.js'
import { mapActions } from 'vuex'

export default {
  name: 'modify-mission',
  mixins: [missionInProgressMixin],
  props: ['itemSelected'],
  components: {
    ModifyMissionFullEdition
  },
  data() {
    return {
      showFullEdition: false,
      optionsToModify: [
        { value: 0, text: 'Modificar Quién (vehículos)' },
        { value: 1, text: 'Modificar Qué y Dónde (zonas)' },
        { value: 2, text: 'Modificar Cuándo (fechas y horas)' }
      ],
      optionSelected: null
    }
  },
  methods: {
    ...mapActions(['getVehiclesInAMission', 'clearVehiclesInAMission']),
    cancelFullEdition() {
      this.showFullEdition = false
      this.clearVehiclesInAMission()
      this.$emit('cancelAction')
    },
    async nextStep() {
      // console.log('NEXT STEP', this.optionSelected, this.itemSelected)
      this.changeAction()
      await this.getVehiclesInAMission(this.itemSelected.missionID)
      this.showFullEdition = true
    },
    optionSelectedChanges() {
      this.$nextTick(() => {
        // console.log('OPTION SELECTED', this.optionSelected)
        this.changeAction()
      })
    },
    finishAction() {
      this.$emit('finishAction')
    }
  }
}
</script>

<style lang="stylus" scoped>
.container-info
  background-color #616161
  border-radius 5px
</style>



// WEBPACK FOOTER //
// src/components/Missions/ActionsMissions/ModifyMission.vue